import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HomeComponent } from './home-page/home.component';
import { WidgetsModule } from '../widgets/widgets.module';
import { GlobalModule } from '../global/global.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		GlobalModule,
		WidgetsModule
	],
	declarations: [
		HomeComponent,
		PageNotFoundComponent
	]
})
export class HomeModule { }